import React from 'react';
import { CKEditor, CKEditorEventPayload } from 'ckeditor4-react';
import appConfig from '@/lib/config';

export interface CKEditorWrapperProps {
  // eslint-disable-next-line react/require-default-props
  id?: string;
  name: string;
  // eslint-disable-next-line react/require-default-props
  initData?: string;
  value: string;
  setValue: (name: any, value: any) => void;
  // eslint-disable-next-line react/no-unused-prop-types
  onChange: (e: any) => void;
  // eslint-disable-next-line react/require-default-props
  config?: Record<string, unknown>;
  // eslint-disable-next-line react/no-unused-prop-types, react/require-default-props
  toolbar?: 'minimal' | 'basic' | 'extended';
  onInstanceReady?: (e: CKEditorEventPayload<'instanceReady'>) => void;
  readOnly?: boolean;
}

const CKEditorToolbars = {
  minimal: {
    toolbar: [['Bold', 'Italic', 'Underline', 'NumberedList', 'Link', 'Image']],
  },
  basic: {
    toolbar: [
      [
        'Sourcedialog',
        'BulletedList',
        'NumberedList',
        'Table',
        'Format',
        'Font',
        'FontSize',
        'Bold',
        'Italic',
        'Underline',
        'Link',
        'Unlink',
      ],
      ['Undo', 'Redo'],
    ],
  },
  extended: {
    toolbar: [
      [
        'Format',
        'Font',
        'FontSize',
        'Bold',
        'Italic',
        'Underline',
        'Link',
        'Unlink',
      ],
      [
        'JustifyLeft',
        'JustifyCenter',
        'JustifyRight',
        'JustifyBlock',
        'NumberedList',
        'BulletedList',
        'Image',
      ],
      ['Undo', 'Redo'],
    ],
  },
};

const CKEditorWrapper = React.forwardRef(
  (
    {
      id,
      name,
      initData,
      value,
      setValue,
      onChange,
      config,
      toolbar,
      onInstanceReady,
      readOnly,
    }: CKEditorWrapperProps,
    ref: React.ForwardedRef<HTMLTextAreaElement>,
  ) => {
    const handleEditorChange = (element: any) => {
      const editorContent = element.editor.getData();
      setValue(name, editorContent);
    };
    const editorConfig = {
      sharedSpaces: { top: '' },
      ...(toolbar ? CKEditorToolbars[toolbar] : {}),
      ...config,
      uiColor: '#FFFFFF',
    };

    return (
      <div id={id} data-testid={`CKEditorWrapper-${id}`}>
        <textarea
          onChange={onChange}
          value={value}
          style={{ display: 'none' }}
          ref={ref}
        />
        <CKEditor
          editorUrl={appConfig.ckEditorScriptUrl}
          onInstanceReady={onInstanceReady}
          initData={initData}
          type="classic"
          onChange={handleEditorChange}
          config={editorConfig}
          readOnly={readOnly}
          style={{
            borderRadius: '6px',
            border: '1px solid rgba(0, 0, 0, 0.14)',
            overflow: 'hidden',
          }}
        />
      </div>
    );
  },
);

CKEditorWrapper.defaultProps = {
  onInstanceReady: (e: CKEditorEventPayload<'instanceReady'>) => {
    e?.editor?.setData('');
  },
  readOnly: false,
};

export default CKEditorWrapper;
